import React from "react"

const PrivacyPolicy = () => {
  return (
    null
  )
}

export default PrivacyPolicy;